// Each mega menu panel is rendered once, in the desktop tree. Moving it between the
// matching desktop and mobile slots keeps scripts and element ids from being duplicated.
const DESKTOP_MEDIA_QUERY = '(min-width: 992px)';
const PANEL_KEY_ATTRIBUTE = 'data-mega-panel';

/** Maps every slot in one nav by its panel key, ignoring later duplicates of a key. */
function mapSlots(nav: HTMLElement): Record<string, HTMLElement> {
  const slots: Record<string, HTMLElement> = {};

  nav.querySelectorAll<HTMLElement>('.mega-panel-slot').forEach((slot) => {
    const key = slot.getAttribute(PANEL_KEY_ATTRIBUTE);

    if (key && !slots[key]) {
      slots[key] = slot;
    }
  });

  return slots;
}

/**
 * Moves every panel into its matching slot in the nav that is currently shown.
 * Panels are moved, never cloned, and a key with no slot in that nav is left alone.
 */
function placePanels(targetNav: HTMLElement): void {
  const slots = mapSlots(targetNav);

  document.querySelectorAll<HTMLElement>('.mega-panel').forEach((panel) => {
    const key = panel.getAttribute(PANEL_KEY_ATTRIBUTE);

    if (!key) {
      return;
    }

    const slot = slots[key];

    // Already in place at this breakpoint, so skip the move and the reflow it would cost.
    if (!slot || panel.parentElement === slot) {
      return;
    }

    slot.appendChild(panel);
  });
}

/** Wires the breakpoint switch; does nothing on pages whose header has no mega menu. */
function handleMegaMenuPanels(): void {
  const desktopNav = document.getElementById('main-navigation-desktop');
  const mobileNav = document.getElementById('main-navigation-mobile');

  if (!desktopNav || !mobileNav || typeof window.matchMedia !== 'function') {
    return;
  }

  const query = window.matchMedia(DESKTOP_MEDIA_QUERY);
  const place = (isDesktop: boolean): void => placePanels(isDesktop ? desktopNav : mobileNav);

  place(query.matches);
  query.addEventListener('change', (event) => place(event.matches));
}

document.addEventListener('DOMContentLoaded', () => {
  handleMegaMenuPanels();
});
